import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const SprzedazZrealizowanaPage = lazy(
	() => import("@/features/reports/sprzedaz-zrealizowana-page"),
);

// `.catch(undefined)` na kazdym polu — zly param ze starego bookmarka ma zostac
// zignorowany, a nie wywalic trase ZodErrorem (FARMASTER-FRONTEND-31/33/34).
//
// Rok ma dolna granice 2021, bo tyle historii sprzedazy ma baza; backend
// odrzuca wczesniejszy 400-ka, wiec strona nie ma go czym pokazac.
// `z.coerce.boolean()` jest tu PULAPKA: dla stringa "false" daje `true`
// (JS castuje niepusty string), wiec `?includeReturns=false` wlaczyloby zwroty
// zamiast je wylaczyc. Parser TanStacka bywa zreszta szybszy i odda juz
// `false` — musimy przyjac obie postaci.
const flaga = z
	.union([z.boolean(), z.string(), z.number()])
	.transform((v) => v === true || v === "true" || v === 1)
	.optional()
	.catch(undefined);

const searchSchema = z.object({
	year: z.coerce.number().int().min(2021).max(2100).optional().catch(undefined),
	month: z.coerce.number().int().min(1).max(12).optional().catch(undefined),
	scope: z.string().optional().catch(undefined),
	// Booleany trzymamy jako odchylenia od FM1: brak parametru = zachowanie FM1.
	includeReturns: flaga,
	includePaca: flaga,
	onlyVatInvoices: flaga,
	includeNoDocument: flaga,
});

export type SprzedazZrealizowanaSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/sprzedaz-zrealizowana")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sprzedaz-zrealizowana",
			location.pathname,
		);
	},
	component: SprzedazZrealizowanaPage,
	validateSearch: (search: Record<string, unknown>): SprzedazZrealizowanaSearch =>
		searchSchema.parse(search),
});
